"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAxiom = exports.Logger = exports.log = exports.reportWebVitals = void 0;
var webVitals_1 = require("./webVitals");
Object.defineProperty(exports, "reportWebVitals", { enumerable: true, get: function () { return webVitals_1.reportWebVitals; } });
var logger_1 = require("./logger");
Object.defineProperty(exports, "log", { enumerable: true, get: function () { return logger_1.log; } });
Object.defineProperty(exports, "Logger", { enumerable: true, get: function () { return logger_1.Logger; } });
var withAxiom_1 = require("./withAxiom");
Object.defineProperty(exports, "withAxiom", { enumerable: true, get: function () { return withAxiom_1.withAxiom; } });
//# sourceMappingURL=index.js.map